import { StorefrontModule } from '@vue-storefront/core/lib/modules'
import Vue from 'vue'

import { GA } from './ga4';

export const GoogleTagManager: StorefrontModule = function () {
  Vue.prototype.$googleTagManager = new GA()
}
